import { h } from '@stencil/core';
import cn from 'classnames';
import { EQdsButtonImportance, EQdsButtonSize, pesIconMirrorDirection, pesIconSizes } from '@pes-ui/utils';
export class BusinessLinesView {
  constructor() {
    this.linesList = undefined;
    this.topTangesLabel = undefined;
    this.viewOnLabel = undefined;
    this.productsLabel = undefined;
    this.productRelationsViewProdLabel = undefined;
    this.seeAllOffersLink = undefined;
    this.mostViewedProductsLabel = undefined;
    this.learnMoreLabel = undefined;
    this.business = undefined;
    this.activeLine = undefined;
    this.isMobile = undefined;
    this.iconNameMap = undefined;
    this.carouselSelectCell = -1;
    this.breadcrumbs = undefined;
    this.storageName = undefined;
    this.isPBS = false;
    this.el.dir = document.documentElement.dir || 'auto';
  }
  findIcon(id) {
    var _a;
    return (_a = this.iconNameMap[id]) !== null && _a !== void 0 ? _a : '';
  }
  isActive(id) {
    var _a, _b;
    return ((_a = this.activeLine) === null || _a === void 0 ? void 0 : _a.id) && ((_b = this.activeLine) === null || _b === void 0 ? void 0 : _b.id) === id;
  }
  renderItems() {
    var _a;
    return (_a = this.linesList) === null || _a === void 0 ? void 0 : _a.map((business) => (h("span", { class: "business-lines__item swiper-slide", id: business === null || business === void 0 ? void 0 : business.id, key: business === null || business === void 0 ? void 0 : business.id }, h("button", { onClick: () => this.businessLineDidClick.emit(business), class: cn('business-lines__button', {
        'business-lines__button--active': this.isActive(business === null || business === void 0 ? void 0 : business.id),
      }) }, h("pes-icon", { class: "business-lines__icon business-lines__icon--hero", color: "primary", size: this.isMobile ? pesIconSizes.SMALL : pesIconSizes.MEDIUM }, this.findIcon(business.sourceId)), h("div", { class: "business-lines__name-wrapper" }, h("span", { class: "business-lines__name" }, business.name), business.toprunners ? (h("pes-icon", { size: pesIconSizes.MICRO, class: "business-lines__icon business-lines__icon--closed", mirror: business.toprunners ? undefined : pesIconMirrorDirection.HORIZONTAL }, "arrow2_down")) : (h("pes-icon", { size: pesIconSizes.NANO, class: "business-lines__icon business-lines__icon--closed", mirror: business.toprunners ? undefined : pesIconMirrorDirection.HORIZONTAL }, "arrow2_left")), h("pes-icon", { size: pesIconSizes.MICRO, class: "business-lines__icon business-lines__icon--opened", mirror: pesIconMirrorDirection.VERTICAL }, "arrow2_down"))), this.isActive(business === null || business === void 0 ? void 0 : business.id)
      && this.isMobile && [
      h("h3", { class: "business-lines__header" }, this.topTangesLabel),
      h("pes-top-runners", { list: this.activeLine.toprunners, viewOnLabel: this.viewOnLabel, productsLabel: this.productsLabel, isMobile: this.isMobile, smallCard: true, storageName: this.storageName, breadcrumbs: this.breadcrumbs }),
      h("pes-menu-category", { topTangesLabel: this.topTangesLabel, viewOnLabel: this.viewOnLabel, productRelationsViewProdLabel: this.productRelationsViewProdLabel, seeAllOffersLink: this.seeAllOffersLink, mostViewedProductsLabel: this.mostViewedProductsLabel, menuList: this.activeLine.categories, business: this.business, isMobile: this.isMobile, isPBS: this.isPBS }),
      !this.isPBS && business.url && (h("div", { dir: this.el.dir, class: "business-lines__link-wrapper" }, h("qds-standalone-link", { href: business.url, size: EQdsButtonSize.STANDARD, importance: EQdsButtonImportance.EMPHASIZED }, this.learnMoreLabel))),
    ])));
  }
  render() {
    return this.isMobile ? (h("div", { class: "business-lines business-lines--view" }, this.renderItems())) : (h("pes-business-lines-carousel", { class: "business-lines", selectCell: this.carouselSelectCell }, this.renderItems()));
  }
  static get is() { return "pes-business-lines-view"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() {
    return {
      "$": ["business-lines-view.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["business-lines-view.css"]
    };
  }
  static get properties() {
    return {
      "linesList": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "CategoriesApi.ProductsAllBusinesses[]",
          "resolved": "ProductsAllBusinesses[]",
          "references": {
            "CategoriesApi": {
              "location": "import",
              "path": "@pes-ui/utils"
            }
          }
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "topTangesLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "top-tanges-label",
        "reflect": false
      },
      "viewOnLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "view-on-label",
        "reflect": false
      },
      "productsLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "products-label",
        "reflect": false
      },
      "productRelationsViewProdLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "product-relations-view-prod-label",
        "reflect": false
      },
      "seeAllOffersLink": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "see-all-offers-link",
        "reflect": false
      },
      "mostViewedProductsLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "most-viewed-products-label",
        "reflect": false
      },
      "learnMoreLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "learn-more-label",
        "reflect": false
      },
      "business": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "CategoriesApi.ProductsAllCategoriesCategory[]",
          "resolved": "ProductsAllCategoriesCategory[]",
          "references": {
            "CategoriesApi": {
              "location": "import",
              "path": "@pes-ui/utils"
            }
          }
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "activeLine": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "CategoriesApi.ProductsAllBusinesses",
          "resolved": "{ url?: string; categories?: ProductsAllCategories[]; id?: string; name?: string; sourceId?: string; toprunners?: ProductsAllToprunners[]; }",
          "references": {
            "CategoriesApi": {
              "location": "import",
              "path": "@pes-ui/utils"
            }
          }
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "isMobile": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "is-mobile",
        "reflect": false
      },
      "iconNameMap": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "Record<string, string>",
          "resolved": "{ [x: string]: string; }",
          "references": {
            "Record": {
              "location": "global"
            }
          }
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "carouselSelectCell": {
        "type": "number",
        "mutable": false,
        "complexType": {
          "original": "number",
          "resolved": "number",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "carousel-select-cell",
        "reflect": false,
        "defaultValue": "-1"
      },
      "breadcrumbs": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "TBreadcrumbs[]",
          "resolved": "TBreadcrumbs[]",
          "references": {
            "TBreadcrumbs": {
              "location": "import",
              "path": "@pes-ui/utils"
            }
          }
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": "breadcrumbs array for saving in indexDB"
        }
      },
      "storageName": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": "storageName in indexDB for saving breadcrumbs"
        },
        "attribute": "storage-name",
        "reflect": false
      },
      "isPBS": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Defines whether the component is integrated to PBS."
        },
        "attribute": "is-p-b-s",
        "reflect": false,
        "defaultValue": "false"
      }
    };
  }
  static get events() {
    return [{
        "method": "businessLineDidClick",
        "name": "businessLineDidClick",
        "bubbles": true,
        "cancelable": true,
        "composed": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "complexType": {
          "original": "CategoriesApi.ProductsAllBusinesses",
          "resolved": "{ url?: string; categories?: ProductsAllCategories[]; id?: string; name?: string; sourceId?: string; toprunners?: ProductsAllToprunners[]; }",
          "references": {
            "CategoriesApi": {
              "location": "import",
              "path": "@pes-ui/utils"
            }
          }
        }
      }];
  }
  static get elementRef() { return "el"; }
}
